import React from 'react'
import "./ActivityPopup.css"
import rightArrow from "../../Assets/Svg/rightArrow.svg";

const ActivityCard = ({data, onClickActivity, index}) => {
  return (
     <div key={data?.id} className="ActivityContainer">
            <div className="AcitvityContent">
              <h2 className="AcitvityContentDate">
                Edit {data?.edit}
              </h2>
              <div className="AcitvityTimeContainer">
                <h2 className="AcitvityContentTime" style={{ color: "black" }}>
                  Total :
                </h2>{" "}
                <h2 className="AcitvityContentTime">{data?.total}</h2>
              </div>
            </div>
            <div className="ActivityButton">
              <button onClick={()=>{onClickActivity(index)}}> <img src={rightArrow} alt="" /></button>
            </div>
          </div>
  )
}

export default ActivityCard